goog.provide("shadow.js.shim.module$jszip$vendor$FileSaver");
goog.provide("module$shadow_js_shim_module$jszip$vendor$FileSaver");
shadow.js.shim.module$jszip$vendor$FileSaver = shadow.js.nativeProvides["jszip/vendor/FileSaver"] = shadow$bridge("jszip/vendor/FileSaver");
module$shadow_js_shim_module$jszip$vendor$FileSaver.default = shadow.js.shim.module$jszip$vendor$FileSaver;
